import { TokenRefresh } from "../../Services/lib/auth";
export function parseJwt(token) {
	var base64Url = token.split(".")[1];
	var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
	var jsonPayload = decodeURIComponent(
		atob(base64)
			.split("")
			.map(function (c) {
				return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join("")
	);

	return JSON.parse(jsonPayload);
}

export const tokenRefreshControl = (
	refreshToken,
	username,
	interval,
	setTokens,
	setLogged
) => {
	interval.current = setInterval(() => {
		TokenRefresh({
			body: {
				refreshToken,
				username,
			},
		})
			.then((data) => {
				const dec = parseJwt(data.AccessToken);
				setTokens({
					access_token: data.AccessToken,
					id_token: data.IdToken,
					id: dec.sub,
					group: dec["cognito:groups"][0],
					username: dec.username,
				});
			})
			.catch((err) => {
				console.log(err);
				setTokens({
					access_token: null,
					id_token: null,
					id: null,
					group: null,
					username: null,
				});
				setLogged(false);
			});
	}, 1000 * 60 * 50);
};

export const logOutControl = (Cookie, interval, setTokens, setLogged) => {
	const cookies = new Cookie();
	cookies.remove("refresh_token", {
		path: "/",
	});
	cookies.remove("username", {
		path: "/",
	});
	setTokens({
		access_token: null,
		id_token: null,
		id: null,
		group: null,
		username: null,
	});
	setLogged(false);
	clearInterval(interval.current);
};
